import { Box, Typography, keyframes } from "@mui/material";

import { STEP_TUTORIAL, type StepTutorialTypes } from "../constants/tutorial";
import { claimResources } from "../store";
import type {
  ResourceObjects,
  TokenValleyBlockType,
} from "../types/tokenValley";
import { getResourceGatheringIconBlockTypes } from "../utils/getResourceGatheringIcon";

const floatUp = keyframes`
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-50px);
  }
`;

interface TypesProps {
  playerDataStep: number;
  block: TokenValleyBlockType;
  resourceGathering: ResourceObjects;
  setStepTutorial: (step: StepTutorialTypes) => void;
  setResourceGathering: (resourceGathering: ResourceObjects) => void;
}
const ExtractionIcon = ({
  block,
  playerDataStep,
  setStepTutorial,
  resourceGathering,
  setResourceGathering,
}: TypesProps) => {
  const handleClick = () => {
    if (playerDataStep === 2) {
      setStepTutorial(STEP_TUTORIAL.COLLECT_RESOURCES);
    }
    const resources = block.block_production[0]
      .resource_name as ResourceObjects;
    setResourceGathering(resources);
    setTimeout(() => {
      claimResources({ resource_name: resources });
    }, 1000);
  };

  return (
    getResourceGatheringIconBlockTypes(block.block_type) !== null && (
      <Box
        zIndex={10}
        top={"-20px"}
        left={"25px"}
        display={"flex"}
        position={"absolute"}
        onClick={handleClick}
        sx={{
          animation:
            resourceGathering === block.block_production[0].resource_name
              ? `${floatUp} 1s forwards`
              : "none",
        }}
      >
        <img
          src={getResourceGatheringIconBlockTypes(block.block_type) || ""}
          alt="icon"
          style={{ width: "30px" }}
        />

        {resourceGathering === block.block_production[0].resource_name && (
          <Typography
            noWrap
            color="primary.dark"
            fontSize={"12px"}
            mt={1}
            ml={1}
          >
            +{" "}
            {block.resource_stock &&
              Object.values(block.resource_stock)[0]?.toFixed(0)}
          </Typography>
        )}
      </Box>
    )
  );
};

export default ExtractionIcon;
